export default "//static.tradera.net/touchweb/static/output/images/category-collectibles.e55311ca.svg";